<script>
  import { onMount } from 'svelte'
  import filterClasses, { cssPrefix } from '../helper-classes.js'
  import hljs from 'highlight.js'

  export let id = null
  export let style = null
  export let helperClass = null
  export let languages = null

  let importedClasses = ''
  export { importedClasses as class }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = [`${cssPrefix}hljs`, 'theme-dark']
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))

  let el
  onMount(() => {
    if (languages) {
      hljs.configure({
        languages
      })
    }
    hljs.highlightElement(el)
  })
</script>

<div class={classes.join(' ')} {style} {id}>
  <pre bind:this={el}><code><slot /></code></pre>
</div>
